import { render, staticRenderFns } from "./QOptionReadonly.vue?vue&type=template&id=979f5a3c&scoped=true"
import script from "./QOptionReadonly.vue?vue&type=script&lang=js"
export * from "./QOptionReadonly.vue?vue&type=script&lang=js"
import style0 from "./QOptionReadonly.vue?vue&type=style&index=0&id=979f5a3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "979f5a3c",
  null
  
)

export default component.exports